import styled from 'styled-components'

const List = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 14px;
`

const Button = styled.div`
    cursor: pointer;
    padding: 11px 24px;
    border: 2px solid ${({ theme }) => theme.colors.greye};
    background-color: ${({ theme }) => theme.colors.white};
    border-radius: 26px;
    color: ${({ theme }) => theme.colors.grey3};
    display: flex;
    align-items: center;
    width: 100%;

    &:hover {
        border-color: ${({ theme }) => theme.colors.dkblue1};
    }
`

const Title = styled.div`
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey3};
    white-space: nowrap;
    margin: 0;
`

const Icon = styled.div`
    display: flex;
    align-items: center;
    margin: 0;
    height: 100%;
    margin-right: 12px;

    i {
        font-size: 18px;
        line-height: 20px;
        color: ${({ theme }) => theme.colors.greybluelt};
    }
`

const Checkbox = styled.input`
    width: 18px;
    height: 18px;
    accent-color: ${({ theme }) => theme.colors.dkblue1};
    cursor: pointer;
    margin-top: 0 !important;
    margin-right: 10px !important;
`

const LabelItem = styled.label`
    display: flex;

    &:has(input:checked) ${Button} {
        border-color: ${({ theme }) => theme.colors.dkblue1};
        background-color: ${({ theme }) => theme.colors.white};
    }

    &:has(input:disabled) ${Button} {
        cursor: auto;

        ${Title} {
            color: #bbbbbb;
        }

        i {
            color: #bbbbbb;
        }
    }
`

export const ShippingGoals = {
    List,
    Button,
    Title,
    Icon,
    Checkbox,
    LabelItem,
}
